import { render, staticRenderFns } from "./FormCaptchaComponent.vue?vue&type=template&id=ea42f478"
import script from "./FormCaptchaComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormCaptchaComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports